import React from "react";
import { withStyles, Button, InputBase } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import DataGrid from "../../../../dataGrid";
import styles from "../../styles";
import GridConfig from "./GridConfig";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import TerminalUpdateForm from "./UpdateForm";
import MESSAGES from "../../../../../appMessages";
import StatusBar from "../../../../dataGrid/StatusBar";
import DeleteDialog from "./DeleteDialog";
import { withTerminalsHOC } from "../../common/withTerminalsHOC";
import ClearAllFilterButton from "../../../../dataGrid/columnFilters/ClearAllFilterButton";

const localStyles = (theme) => ({
  terminalGrid: {
    margin: "20 0 60 0",
  },
  statusBar: {
    margin: "unset",
    padding: 6,
    border: `1px solid ${theme.AppBGColor}`,
  },
  paperAnchor: {
    position: "absolute",
    width: 380,
    zIndex: 1,
    backgroundColor: theme.ModalBGColor,
  },
});

class FeederTerminal extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.state = {
      feederTerminalData: null,
      showTerminalUpdatePanel: false,
      showDeleteTerminalDialog: false,
      quickFilterText: "",
      selectedTerminalData: null,
      selectedTerminal: null,
      terminalUpdateInProgress: false,
      isDataLoaded: false,
    };
    this.terminalData = [];
    this.terminalOptions = [];
  }

  componentDidMount() {
    this._isComponentMounted = true;
    this.loadFeederTerminalsData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.terminalList !== this.props.terminalList) {
      this.setTerminalOptionsAndTerminalData(this.props.terminalList);
      this.setState({
        feederTerminalData: this.getTerminalAndFeederTerminalMappedData(
          this.state.feederTerminalData ?? []
        ),
      });
      if (this.props.TerminalDataMessage === "error") {
        this.props.enqueueSnackbar(
          MESSAGES.TERMINAL_ACCESS.FETCH_DATA_FAILURE,
          { variant: "error" }
        );
      }
    }
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.runCommand = this.runCommand;
  };

  getTerminalAndFeederTerminalMappedData = (feederTerminalList) => {
    return feederTerminalList.map((ft) => {
      const matchedTerminal =
        this.terminalData.find((t) => t.terminalCode === ft.terminalCode) ?? {};
      return {
        ...ft,
        divisionName: matchedTerminal.divisionName,
        regionName: matchedTerminal.regionName,
      };
    });
  };

  setTerminalOptionsAndTerminalData = (terminalData) => {
    this.terminalData = terminalData;
    this.terminalOptions = terminalData.map((t) => ({
      value: t.terminalId,
      label: t.terminalCode,
      isTerminalLocation: t.isTerminalLocation,
    }));
  };

  loadFeederTerminalsData = () => {
    getDataWithQueryString("GetFeederTerminal").then(
      (response) => {
        if (this._isComponentMounted) {
          if (response?.status >= 200 && response?.status < 400) {
            this.setState({
              feederTerminalData: this.getTerminalAndFeederTerminalMappedData(
                response.data
              ),
              isDataLoaded: true,
            });
          } else {
            this.setState({
              feederTerminalData: [],
              isDataLoaded: true,
            });
            this.props.enqueueSnackbar(
              MESSAGES.TERMINAL_ACCESS.FETCH_DATA_FAILURE,
              { variant: "error" }
            );
          }
        }
      },
      (_error) => {
        if (this._isComponentMounted) {
          this.setState({
            feederTerminalData: [],
            isDataLoaded: true,
          });
          this.props.enqueueSnackbar(
            MESSAGES.TERMINAL_ACCESS.FETCH_DATA_FAILURE,
            { variant: "error" }
          );
        }
      }
    );
  };

  setSelectedTerminalData = (terminalData) => {
    this.setState({
      selectedTerminalData: terminalData,
      showDeleteTerminalDialog: true,
    });
  };

  closeDeleteTerminalDialog = () => {
    this.setState({
      selectedTerminalData: null,
      showDeleteTerminalDialog: false,
    });
  };

  setSelectedTerminal = () => {
    if (this.state.selectedTerminal && this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (this.state.selectedTerminal === node.data.terminalCode) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true);
        } else {
          node.setSelected(false);
        }
      });
    }
  };

  runCommand = (command, props) => {
    const terminalData = { ...props.data };
    switch (command) {
      case "editFeederTerminal":
        this.editTerminalInfo(terminalData);
        break;
      case "deleteFeederTerminal":
        this.setSelectedTerminalData(terminalData);
        break;
      default:
        break;
    }
    this.setState({
      selectedTerminal: terminalData.terminalCode,
    });
  };

  editTerminalInfo = (terminalData) => {
    this.setState({
      selectedTerminalData: terminalData,
      showTerminalUpdatePanel: true,
      isCreateTerminalFlow: false,
    });
  };

  openAddTerminalPanel = () => {
    this.setState({
      selectedTerminalData: null,
      showTerminalUpdatePanel: true,
      isCreateTerminalFlow: true,
    });
  };

  closeAddTerminalPanel = () => {
    this.setState({
      showTerminalUpdatePanel: false,
    });
  };

  updateQuickFilterText = (event) => {
    this.setState({
      quickFilterText: event.target.value,
    });
  };

  constructStatusBar = (filteredTerminalData) => {
    return [
      {
        label: `${filteredTerminalData.length} Terminals`,
      },
    ];
  };

  updateCreateTerminalToUpdateTerminal = () => {
    this.setState({
      isCreateTerminalFlow: false,
    });
  };

  updateModel = ({
    selectedTerminal,
    terminalUpdateInProgress,
    showTerminalUpdatePanel = true,
  }) => {
    this.setState({
      selectedTerminal,
      terminalUpdateInProgress,
      showTerminalUpdatePanel,
    });
    if (!showTerminalUpdatePanel) {
      this.loadFeederTerminalsData();
    }
  };

  render() {
    const { classes } = this.props;
    const {
      showDeleteTerminalDialog,
      showTerminalUpdatePanel,
      selectedTerminalData,
      terminalUpdateInProgress,
      quickFilterText,
      isCreateTerminalFlow,
      feederTerminalData,
      isDataLoaded,
      selectedTerminal,
    } = this.state;
    return (
      <>
        <header
          className={classes.moduleHeader}
          data-automationid="feederTerminal-title"
        >
          Feeder Terminals
        </header>
        <div className={classes.moduleContainer}>
          <div
            className={`${classes.gridContainer} ${classes.feederTerminalGridContainer}`}
          >
            <div className={classes.gridHead}>
              <span className={classes.gridActionIcons}>
                <div className={classes.searchContainer}>
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                  <InputBase
                    placeholder="Search…"
                    classes={{
                      root: classes.searchInputRoot,
                      input: classes.searchInput,
                    }}
                    onChange={this.updateQuickFilterText}
                  />
                </div>
              </span>
              <ClearAllFilterButton gridApi={this.gridApi} />
              <div className={classes.actionContainer}>
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  classes={{ root: classes.actionButton }}
                  onClick={this.openAddTerminalPanel}
                  data-automationid="addFeederTerminals"
                  disabled={!isDataLoaded}
                >
                  Add Feeder Terminal
                </Button>
              </div>
            </div>

            <div
              className={`${classes.dataGrid} ${classes.terminalGrid} ${classes.feederTerminalGridHeight}`}
            >
              <DataGrid
                defaultColDef={this.gridConfig.config.defaultColDef}
                columnDefs={this.gridConfig.config.columns}
                config={this.gridConfig.config}
                enableFilter={this.gridConfig.config.enableFilter}
                enableSorting={this.gridConfig.config.enableSorting}
                rowSelection={this.gridConfig.config.rowSelection}
                rowData={feederTerminalData}
                onGridReady={this.onGridReady}
                quickFilterText={quickFilterText}
                onRowDataChanged={this.setSelectedTerminal}
                panelLabel={(filteredData) => (
                  <StatusBar
                    data={this.constructStatusBar(filteredData)}
                    customClass={classes.statusBar}
                  />
                )}
              />
            </div>
          </div>
        </div>
        {showTerminalUpdatePanel && (
          <TerminalUpdateForm
            terminalOptions={this.terminalOptions}
            selectedTerminalData={selectedTerminalData}
            open={showTerminalUpdatePanel}
            onClose={this.closeAddTerminalPanel}
            onCreateOrUpdateTerminal={this.createOrUpdateTerminal}
            terminalUpdateInProgress={terminalUpdateInProgress}
            isCreateTerminalFlow={isCreateTerminalFlow}
            drawerClasses={{
              paper: classes.paperAnchor,
            }}
            variant="persistent"
            feederTerminalData={feederTerminalData}
            updateCreateTerminalToUpdateTerminal={
              this.updateCreateTerminalToUpdateTerminal
            }
            updateModel={this.updateModel}
          />
        )}
        {showDeleteTerminalDialog && (
          <DeleteDialog
            selectedTerminal={selectedTerminal}
            enqueueSnackbar={this.props.enqueueSnackbar}
            closeDeleteTerminalDialog={this.closeDeleteTerminalDialog}
            loadFeederTerminalsData={this.loadFeederTerminalsData}
          />
        )}
      </>
    );
  }
}

export default compose(
  withStyles((theme) => ({
    ...styles(theme),
    ...localStyles(theme),
  })),
  withUserProfile,
  withSnackbar
)(withTerminalsHOC(FeederTerminal));
